import React, { useState } from 'react';

function AddPost() {
  const [formData, setFormData] = useState({
    category: 'Verified Offsets & Projects',
    title: 'Switch to Renewable Energy with EcoGrid and Earn CCRTs',
    description: `As the world grapples with climate change and dwindling fossil fuel reserves, renewable energy has emerged as a beacon of hope. This article explores the transformative potential of solar, wind, hydro, and other clean energy sources, examining how innovations in technology, policy, and infrastructure are accelerating the global shift toward sustainability. We're excited to partner with Global Footprint Network to improve carbon accounting accuracy and educate users on ecological overshoot. Expect deeper insights and [14px]arter reductions. explores the transformative potential of solar, wind, hydro, and other clean energy sources, examining how innovations in technology.`,
    advertOutlet: 'EcoGrid Climate Services',
    link: 'https://www.ecosparkenergy.com/articles/solar-farming-benefits'
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    console.log('Image:', selectedImage);
    // Add your submit logic here
  };

  const handleReject = () => {
    console.log('Rejected');
    // Add reject logic here
  };

  return (
    <div className="">
    

      <div className="ml-[20px] p-8">
        <form onSubmit={handleSubmit}>
          {/* Main Card */}
          <div className="w-[1062px] border border-[#038B47] rounded-3xl bg-white p-8">
            
            {/* Image Upload Section */}
            <div className="flex flex-col gap-4 mb-8">
              <span className="text-[14px] font-normal text-[#898989]">
                Upload a high quality image
              </span>
              
              <div className="flex flex-col gap-4">
                <label className="text-[14px] font-medium text-[#101828]">
                  Image
                </label>
                
                <div className="w-full h-[177px] border border-[#D4D4D8] rounded-xl overflow-hidden relative bg-cover bg-center">
                  {imagePreview ? (
                    <>
                      <img 
                        src={imagePreview} 
                        alt="Uploaded" 
                        className="w-full h-full object-cover"
                      />
                      <button
                        type="button"
                        onClick={handleRemoveImage}
                        className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
                      >
                        <div className="relative w-4 h-4">
                          <div className="absolute inset-0 flex items-center justify-center">
                            <div className="w-4 h-4 bg-white rounded-full"></div>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M1 1L13 13M13 1L1 13" stroke="#101828" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                          </div>
                        </div>
                      </button>
                    </>
                  ) : (
                    <label className="w-full h-full flex items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="hidden"
                      />
                      <div className="text-center">
                        <svg className="mx-auto mb-2" width="48" height="48" viewBox="0 0 48 48" fill="none">
                          <circle cx="24" cy="24" r="20" fill="#F0F0F0"/>
                          <path d="M24 16V32M16 24H32" stroke="#101828" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        <span className="text-[14px] text-[#898989]">Click to upload image</span>
                      </div>
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Category */}
            <div className="flex flex-col gap-[18px] mb-8">
              <label className="text-[14px] font-medium text-[#101828]">
                Category
              </label>
              <div className="relative">
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  className="w-full h-[52px] px-3 border border-[#D4D4D8] rounded-xl appearance-none bg-white text-[14px] text-[#434343] focus:outline-none focus:ring-2 focus:ring-[#038B47] focus:border-transparent"
                >
                  <option value="Verified Offsets & Projects">Verified Offsets & Projects</option>
                  <option value="Sustainable Brands & Services">Sustainable Brands & Services</option>
                  <option value="Partnership Spotlights">Partnership Spotlights</option>
                  <option value="Climate Impact Stories">Climate Impact Stories</option>
                  <option value="Earn & Save">Earn & Save</option>
                </select>
                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9L12 15L18 9" stroke="#757575" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>

            {/* Title */}
            <div className="flex flex-col gap-[18px] mb-8">
              <label className="text-[14px] font-medium text-[#101828]">
                Title
              </label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="w-full h-[52px] px-3 border border-[#D4D4D8] rounded-xl text-[14px] text-[#514A4A] focus:outline-none focus:ring-2 focus:ring-[#038B47] focus:border-transparent"
                placeholder="Enter title"
              />
            </div>

            {/* Description */}
            <div className="flex flex-col gap-[18px] mb-8">
              <label className="text-[14px] font-medium text-[#101828]">
                Description
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                rows={6}
                className="w-full p-3 border border-[#D4D4D8] rounded-xl text-[14px] text-[#434343] resize-none focus:outline-none focus:ring-2 focus:ring-[#038B47] focus:border-transparent"
                placeholder="Enter description"
              />
            </div>

            {/* Advert Outlet */}
            <div className="flex flex-col gap-[18px] mb-8">
              <label className="text-[14px] font-medium text-[#101828]">
                Advert Outlet
              </label>
              <input
                type="text"
                name="advertOutlet"
                value={formData.advertOutlet}
                onChange={handleInputChange}
                className="w-full h-[52px] px-3 border border-[#D4D4D8] rounded-xl text-[14px] text-[#514A4A] focus:outline-none focus:ring-2 focus:ring-[#038B47] focus:border-transparent"
                placeholder="Enter advert outlet"
              />
            </div>

            {/* Add Link */}
            <div className="flex flex-col gap-[18px] mb-8">
              <label className="text-[14px] font-medium text-[#101828]">
                Add Link
              </label>
              <input
                type="url"
                name="link"
                value={formData.link}
                onChange={handleInputChange}
                className="w-full h-[52px] px-3 border border-[#D4D4D8] rounded-xl text-[14px] text-black focus:outline-none focus:ring-2 focus:ring-[#038B47] focus:border-transparent"
                placeholder="Enter URL"
              />
            </div>

            {/* Action Buttons */}
            <div className="flex items-end gap-8 mt-4">
              <button
                type="button"
                onClick={handleReject}
                className="w-[202px] h-[54px] px-4 py-[18px] bg-white rounded-lg border border-[#038B47] hover:bg-gray-50 transition-colors flex items-center justify-center"
              >
                <span className="text-[12px] font-semibold text-[#038B47]">Save as Draft</span>
              </button>
              
              <button
                type="submit"
                className="w-[202px] h-[52px] px-4 py-2 bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center"
              >
                <span className="text-[12px] font-semibold text-white">Publish</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddPost;